import { FAIRE_SPAN_ID_TRACKING, TelemetryManager } from "../../opentelemetry/TelemetryManager";
import { getSettingEnableDetailedSessionTracing } from "../../settings/getSettingEnableDetailedSessionTracing";
export var opentelemetryResponseInterceptor = function(request, response) {
    var spanId = request === null || request === void 0 ? void 0 : request.headers[FAIRE_SPAN_ID_TRACKING];
    if (!getSettingEnableDetailedSessionTracing() || !spanId) {
        return response;
    }
    var _response_status;
    // Add Status code to span when ending the span
    TelemetryManager.get().endManagedSpan(spanId, {
        "http.status_code": (_response_status = response.status) !== null && _response_status !== void 0 ? _response_status : "unknown"
    });
    return response;
};
